import { keypadProgrammingReducer } from './services/keypads.service';

export const QUICKSTART_KEYPADS_REDUCERS: any = {
  keypadProgramming: keypadProgrammingReducer
};



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-keypads/quickstart-keypads.stores.ts